import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { CheckCircle, ErrorOutline, Warning, InfoOutlined, HelpOutline } from "@material-ui/icons";

const variants = {
    success: { icon: CheckCircle, color: "#15803d", background: "#ecfdf5", title: "ดำเนินการสำเร็จ" },
    error: { icon: ErrorOutline, color: "#dc2626", background: "#fef2f2", title: "ดำเนินการไม่สำเร็จ" },
    warning: { icon: Warning, color: "#b45309", background: "#fffbeb", title: "กรุณาตรวจสอบข้อมูล" },
    info: { icon: InfoOutlined, color: "#0369a1", background: "#f0f9ff", title: "แจ้งให้ทราบ" },
    confirm: { icon: HelpOutline, color: "#b45309", background: "#fffbeb", title: "ยืนยันการดำเนินการ" }
};
const queue = [];
let host;
let showing = false;
const next = () => {
    if (showing || !queue.length) return;
    showing = true;
    if (!host) { host = document.createElement("div"); host.dataset.budgetAlerts = "true"; document.body.appendChild(host); }
    const { type, message, resolve } = queue.shift();
    const variant = variants[type];
    const Icon = variant.icon;
    const close = value => {
        ReactDOM.unmountComponentAtNode(host);
        showing = false;
        resolve(value);
        next();
    };
    ReactDOM.render(<Modal isOpen appElement={document.getElementById("root") || undefined} ariaHideApp={!!document.getElementById("root")} role="alertdialog" aria={{ labelledby: "budget-alert-title", describedby: "budget-alert-message" }}
        onRequestClose={() => close(type !== "confirm")} shouldCloseOnOverlayClick={false}
        style={{ overlay: { backgroundColor: "rgba(15,23,42,0.55)", zIndex: 2000, backdropFilter: "blur(3px)" }, content: {
            inset: "50% auto auto 50%", transform: "translate(-50%, -50%)", width: "440px", maxWidth: "calc(100vw - 32px)",
            maxHeight: "85vh", overflowY: "auto", boxSizing: "border-box", border: "none", borderRadius: "20px",
            padding: "32px 28px", boxShadow: "0 24px 70px rgba(15,23,42,.25)", textAlign: "center", fontFamily: '"Sarabun", sans-serif'
        } }}>
        <div style={{ display: "inline-flex", padding: "18px", borderRadius: "50%", backgroundColor: variant.background, color: variant.color }}><Icon style={{ fontSize: "48px" }} aria-hidden="true" /></div>
        <h4 id="budget-alert-title" style={{ margin: "20px 0 12px", fontWeight: 600, color: "#0f172a" }}>{variant.title}</h4>
        <p id="budget-alert-message" style={{ color: "#475569", fontSize: "16px", lineHeight: 1.8, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{message}</p>
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "12px", marginTop: "26px" }}>
            {type === "confirm" && <button type="button" autoFocus className="btn btn-light" style={{ minWidth: "110px", borderRadius: "10px" }} onClick={() => close(false)}>ยกเลิก</button>}
            <button type="button" autoFocus={type !== "confirm"} className="btn" style={{ minWidth: "110px", borderRadius: "10px", backgroundColor: variant.color, color: "#fff" }} onClick={() => close(true)}>{type === "confirm" ? "ยืนยัน" : "ตกลง"}</button>
        </div>
    </Modal>, host);
};
const show = (type, message) => new Promise(resolve => { queue.push({ type, message, resolve }); next(); });
export const budgetAlert = {
    success: message => show("success", message), error: message => show("error", message),
    warning: message => show("warning", message), info: message => show("info", message),
    confirm: message => show("confirm", message)
};

export function BudgetFeedback({ message, type = "error" }) {
    useEffect(() => { if (message) budgetAlert[type](message); }, [message, type]);
    return null;
}
